import 'bootstrap/dist/css/bootstrap.min.css';
import bootstrap from 'bootstrap/dist/js/bootstrap.min';
//import '../../../node_modules/animate.css/animate.compat.css';
import '../../../src/js/valida-campos.js';
import valida_forms from './valida-forms';

import '../css/index.css';
import '../css/registo-empresa.css';
import '../css/msg-container.css';
import '../css/modais.css';
import '../../../icomoon-v1.0/style.css';

import './adiciona-sucursal.js';

import '../file-upload-input/styles.css';
import '../file-upload-input/file-upload-input.js';

import { readURL, removeUpload } from '../file-upload-input/file-upload-input.js';

$(function(){
    $('body').css('visibility', 'visible');
})

// Seleciona o tipo de pacote
$('.card-pacotes').on('click', function () {
    const tipo_pacote = $(this).data('opcao');
    const max_sucursais = $(this).data('max-sucursais');
    $('#max-sucursais-permitidas').text(max_sucursais);
    $('button.btn-add').attr('data-max-sucursais', max_sucursais);
    // apaga os outros
    $('.card-pacotes').not(this).removeClass('selected');
    $('input[name = "pacote_comercial"]').val(tipo_pacote);
    $(this).addClass('selected');
    // apaga as sucursais adicionadas
    $('.border-success').remove();
    $('.row-container-sucursal').css('display', 'block');
    $('.btn-add').css('display', 'block');
    $('input:hidden[name="numero_sucursais"]').val(0);

})
// end seleciona tipo de carga

$('input[name="contribuinte"]').on('input', function (e) {
    var val;
    val = $(this).val().replace(/[^0-9]/g, '');
    $(this).val(val);
})

$('input[name="codigo_postal"], input[name="codigo_postal_novasucursal"]').on('input', function (e) {
    var val;
    val = $(this).val().replace(/[^0-9-]/g, '');
    $(this).val(val);
})

$('input[name="certidao_permanente"]').on('input', function (e) {
    var val;
    val = $(this).val().replace(/[^0-9-]/g, '');
    $(this).val(val);
});

$('input[name^="contacto"]').on('input', function (e) {
    var val;
    val = $(this).val();
    val = val.replace(/[^\+?0-9]/g, '');
    val = val.replace(/[0-9]{1,}[\+]$/g, '+');
    val = val.replace(/^\+{2,}/g, '+');
    $(this).val(val);
})

// Inícia popovers
var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl)
})



var username_popover = new bootstrap.Popover($('.username-help'));
var password_popover = new bootstrap.Popover($('.password-help'));
var codigopostal_popover = new bootstrap.Popover($('.codigopostal-help'));
var codigopostalsucursal_popover = new bootstrap.Popover($('.codigopostalsucursal-help'));
$('.username-help, .password-help, .codigopostal-help, .codigopostalsucursal-help').on('mouseenter', function (e) {
    e.preventDefault();
    if ($(this).hasClass('username-help')) {
        username_popover.show();
    }
    if ($(this).hasClass('password-help')) {
        password_popover.show();
    }
    if ($(this).hasClass('codigopostal-help')) {
        codigopostal_popover.show();
    }
    if ($(this).hasClass('codigopostalsucursal-help')) {
        codigopostalsucursal_popover.show();
    }
}).on('mouseleave', function (e) {
    username_popover.hide();
    password_popover.hide();
    codigopostal_popover.hide();
    codigopostalsucursal_popover.hide();
});


// Para submissão dos forms
$('form').on('submit', function (e) {
    // e.preventDefault();
    if (!valida_forms(this)) {
        return false;
    } else {
        //$('button[data-disableonsubmit]').prop('disabled', true);
        $('button[type="submit"][data-disableonsubmit]').text('Aguarde ...');
        $('button[type="submit"][data-disableonsubmit], a:link').css('pointer-events', 'none');
        $('button[type="submit"][data-disableonsubmit], a:link').css('opacity', 0.5);
        return true;
    }
})


// Para o toggle do campo da password: visível / não visível
$('[data-target=password-toggle]').on('click', function (e) {
    if ($('.password-toggle').attr('type') == 'password') {
        $('.password-toggle').attr('type', 'text');
        $(this).removeClass('icon-eye-blocked');
        $(this).addClass('icon-eye');
    } else {
        $('.password-toggle').attr('type', 'password');
        $(this).removeClass('icon-eye');
        $(this).addClass('icon-eye-blocked');
    }
})

$('[name="password"]').on('input', function () {
    $('[name="password_conf"]').val('');
});

if ($('input[name="contribuinte"]').length > 0)
    $('input[name="contribuinte"]').valida_NIF(); // Para dar início ao script que faz a validação dos NIF

$('button.remove-image').on('click', function () {
    const target_name = $(this).attr('data-input-name');
    removeUpload($('.file-upload-input').filter('[name=' + target_name + ']'));
})

$('.file-upload-btn').on('click', function () {
    $(this).prev().trigger('click');
})

$('.file-upload-input').on('change', function () {
    readURL(this);
});

$('.btn#btn-mb').on('click', function () {
    var btn_backgroundcolor = $(this).css('background-color');
    $(this).attr('style', 'background-color: #cddc39 !important');
    $('.btn#btn-mbway').css('background-color', btn_backgroundcolor);
    $('[name="metodo_pagamento"]').val('multibanco');

});

$('.btn#btn-mbway').on('click', function () {
    var btn_backgroundcolor = $(this).css('background-color');
    $(this).attr('style', 'background-color: #cddc39 !important');
    $('.btn#btn-mb').css('background-color', btn_backgroundcolor);
    $('[name="metodo_pagamento"]').val('mbway');
});

if ($('.msg-container-new').is(':visible')) {
    $('.msg-container-new').on('click', function (event) {
        if (!$(event.target).closest('.msg-content').length)
            $(this).remove();
    })
}
$('.msg-container-new').find('.msg-content').find('button').on('click', function () {
    $('.msg-container-new').remove();
})


$('#btn-plano-personalizado').on('click', function () {
    var nomeempresa_informacoes = $('#nomeempresa-informacoes');
    var nome_informacoes = $('#nome-informacoes');
    var email_informacoes = $('#email-informacoes');
    var contacto_informacoes = $('#contacto-informacoes');
    var contacto_informacoes = $('#contacto-informacoes');
    var nomeempresainformacoes_popover = new bootstrap.Popover($('.nomeempresa-informacoes'));
    var nomeinformacoes_popover = new bootstrap.Popover($('.nome-informacoes'));
    var emailinformacoes_popover = new bootstrap.Popover($('.email-informacoes'));
    var contactoinformacoes_popover = new bootstrap.Popover($('.contacto-informacoes'));

    if (nomeempresa_informacoes.val().trim().length < 5) {
        nomeempresainformacoes_popover.show();
        nomeempresa_informacoes.trigger('focus');
        nomeempresa_informacoes.on('keypress', function () { nomeempresainformacoes_popover.hide(); })
        return false;
    } else {
        nomeempresainformacoes_popover.hide();
    }

    if (!is_Nome(nome_informacoes.val()) || nome_informacoes.val().trim().length < 5) {
        nomeinformacoes_popover.show();
        nome_informacoes.trigger('focus');
        nome_informacoes.on('keypress', function () { nomeinformacoes_popover.hide(); })
        return false;
    } else {
        nomeinformacoes_popover.hide();
    }

    if (!is_Email(email_informacoes.val()) || email_informacoes.val().trim().length < 2) {
        emailinformacoes_popover.show();
        email_informacoes.trigger('focus');
        email_informacoes.on('keypress', function () { emailinformacoes_popover.hide(); })
        return false;
    } else {
        emailinformacoes_popover.hide();
    }

    if (!is_Telefone(contacto_informacoes.val()) || contacto_informacoes.val().trim().length < 8) {
        contactoinformacoes_popover.show();
        contacto_informacoes.trigger('focus');
        contacto_informacoes.on('keypress', function () { contactoinformacoes_popover.hide(); })
        return false;
    } else {
        contactoinformacoes_popover.hide();
    }

    $('this').text('Aguarde ...');
    $('button[type="button"][data-disableonsubmit], a:link').css('pointer-events', 'none');
    $('button[type="button"][data-disableonsubmit], a:link').css('opacity', 0.5);

    $.post("./src/includes/solicitainformacoes-planos.php", { 'nomeempresa_informacoes': nomeempresa_informacoes.val(), 'nome_informacoes': nome_informacoes.val(), 'email_informacoes': email_informacoes.val(), 'contacto_informacoes': contacto_informacoes.val(), 'keyval': 'regemp5r' }, function (data) {
        if (data.resultado == true) {
            // enviou o pedido de informações
            window.location.href = './init.php';
        } else {
            window.location.href = './init.php';
        }
    }, 'json');
});

/* Para mais tarde aproveitar
 
$('button[type=submit]').on('click', function(e) {
var self = this
$(this).prop('disabled', true);
e.preventDefault();
$.post("grava_bd.php", $('form').serialize(), function(data) {
    $.each(data.posts, function(index, value) {
        $(".result").append(value);
        $(self).prop('disabled', false);
    })
 
}, 'json');
})
*/




